import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { loadLanguageMessages } from './i18n'
import './styles.css'

async function start() {
  try {
    await loadLanguageMessages('en')
  }
  catch (error) {
    console.warn('English signup messages could not be preloaded.', error)
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
